export default {"src":"https://fishbrain.com/_next/static/media/catchPositions.3fd8476f.svg","height":36,"width":46,"blurWidth":0,"blurHeight":0};